import * as URLSearchParamsPoly from 'url-search-params-polyfill';
var QUERY_STRING_REGEX = /[?&]/;
function _getURLSearchParam(url) {
  var _URLSearchParam = URLSearchParams || URLSearchParamsPoly;
  return new _URLSearchParam(url);
}
function _updateQltparam(url, qlt) {
  var urlSplit = url && url.split('?');
  var params = urlSplit[1];
  var searchParam = params && _getURLSearchParam(params);
  if (searchParam.has('qlt')) {
    searchParam.set('qlt', qlt);
    return "".concat(urlSplit[0], "?").concat(searchParam.toString());
  }
  return -1;
}

/**
 * @returns url with qlt value updated or added.
 *
 * @param {String} url
 * @param {String} qlt
 */
export default function setQltParam(url, qlt) {
  var querySelector = QUERY_STRING_REGEX.test(url) ? '&' : '?';
  if (querySelector === '&') {
    var _url = _updateQltparam(url, qlt);
    if (_url !== -1) return _url;
  }
  var qltQuery = qlt && "".concat(querySelector, "qlt=").concat(qlt) || '';
  return url && "".concat(url).concat(qltQuery);
}